{
  "linkTo": "Establecer ruta",
  "parkingSpotWithNumber": "Punto {{number}}",
  "pathNotSetWarning": "Ruta lineal no configurada. Establezca una ruta para habilitar las funciones de seguimiento de movimiento lineal.",
  "setLinearPath": "Establecer ruta lineal",
  "stageParkingSpots": {
    "cancelText": "Atrás",
    "instructions": "Establezca los lugares de estacionamiento en la ruta de la estación base.",
    "title": "Lugares de estacionamiento"
  },
  "stagePathEnd": {
    "cancelText": "Atrás",
    "instructions": "Establezca el punto final de la ruta de la estación base tocando el mapa.",
    "title": "Punto final"
  },
  "stagePathStart": {
    "cancelText": "Cancelar",
    "instructions": "Establezca el punto de inicio de la ruta de la estación base tocando el mapa.",
    "title": "Punto de inicio"
  },
  "stageSwath": {
    "cancelText": "Atrás",
    "instructions": "Establezca el ancho de la franja. Pulse \"Girar\" para invertir la dirección de la franja.",
    "title": "Andana"
  },
  "title": "Establecer ruta de movimiento lineal"
}
